import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ClearCartDialogComponentService } from '@spartacus/cart/base/components';
import { I18nModule, RoutingService } from '@spartacus/core';
import { FocusConfig, ICON_TYPE } from '@spartacus/storefront';
 
@Component({
  selector: 'app-custom-clear-cart-modal',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, I18nModule],
  templateUrl: './custom-clear-cart-modal.component.html',
  styleUrl: './custom-clear-cart-modal.component.scss',
})
export class CustomClearCartModalComponent {
  focusConfig: FocusConfig = {
    trap: true,
    block: true,
    autofocus: 'button.btn-primary',
    focusOnEscape: true,
  };
 
  isClearing: boolean = false;
 
  iconTypes = ICON_TYPE;
 
  @HostListener('click', ['$event'])
  handleClick(event: UIEvent): void {
    // Close on click outside the dialog window
    if ((event.target as any).tagName === this.el.nativeElement.tagName) {
      this.close('Cross click');
    }
  }
 
  constructor(
    protected el: ElementRef,
    protected clearCartDialogComponentService: ClearCartDialogComponentService,
    protected routingService: RoutingService
  ) {}
 
  clearCart(): void {
    this.isClearing = true;
    this.clearCartDialogComponentService.deleteActiveCart();
    //REDIRECCIONAR A HOME
    this.routingService.go({ cxRoute: 'home' });
  }
 
  close(reason: string): void {
    this.clearCartDialogComponentService.closeDialog(reason);
  }
 
  ngOnDestroy(): void {
    this.close('close dialog on component destroy');
  }
}